import Constants from 'Constants'
import Data from 'Class/Data'

export default langue => Data.list(Constants.module.CONFIGURATION, Constants.donnee.langue).indexOf(langue) !== -1